import styled from "styled-components";
import FormInput from "./formInput";
import CustomButton from "../customButton";
import { submitPlumberReceipt } from "../../../API/AppRepository";

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 20px;
`;

type FormState = {
  name: string;
  statusCode?: string;
  contact: string;
  itemCode: string;
  address: string;
  addressDetail?: string;
  zipCode: string;
  workDate: string;
  totalPrice?: number;
  memo?: string;
};

type Props = {
  form: FormState;
  onChange: (name: string, value: string) => void;
  onOpenAddressModal: () => void;
  onOpenDateModal: () => void;
  setIsCreateModalOpen: any;
  onSuccess?: () => void;
};

export default function CreatePlumberModal({
  form,
  onChange,
  onOpenAddressModal,
  onOpenDateModal,
  onSuccess,
  setIsCreateModalOpen,
}: Props) {
  const submitPlumber = async () => {
    try {
      await submitPlumberReceipt(form);
      alert("접수완료되었습니다");
      setIsCreateModalOpen(false);
      onSuccess?.();
    } catch (e) {
      console.error("접수 실패", e);
      alert("접수에 실패했습니다");
    }
  };

  return (
    <Wrapper>
      <FormInput
        label="고객명"
        required
        type="text"
        name="name"
        value={form.name}
        placeholder="고객명을 입력하세요. / 특수문자 사용 금지"
        onChange={onChange}
      />
      <FormInput
        label="연락처"
        required
        type="text"
        name="contact"
        value={form.contact}
        placeholder="-없이 번호만 입력"
        onChange={onChange}
      />
      <FormInput
        label="상품종류"
        required
        type="dropdown"
        name="itemCode"
        dropdownOptions={[
          { label: "청년아이넨스배관(P01532)", value: "P01532" },
        ]}
        value={form.itemCode}
        placeholder="상품종류 선택"
        onChange={onChange}
      />
      <FormInput
        label="작업주소"
        required
        type="address"
        name="address"
        value={form.address}
        placeholder="주소검색"
        onChange={onChange}
        onOpenAddressModal={onOpenAddressModal}
      />
      <FormInput
        label="상세주소"
        type="text"
        name="addressDetail"
        value={form.addressDetail || ""}
        placeholder="상세주소를 입력하세요."
        onChange={onChange}
      />
      <FormInput
        label="작업날짜"
        required
        type="date"
        name="workDate"
        value={form.workDate}
        placeholder="날짜 선택"
        onChange={onChange}
        onOpenDateModal={onOpenDateModal}
      />
      <CustomButton
        text="접수하기"
        $bgColor="#0C8CE9"
        height="50px"
        width="100%"
        fontWeight="400"
        size="20px"
        onClick={submitPlumber}
      />
    </Wrapper>
  );
}
